import React, { useState } from "react";
import { compose, withHandlers, withPropsOnChange } from "recompose";
import { range } from "lodash";
import { LocalForm, Control, actions } from "react-redux-form";
import { Trans } from "react-i18next";
import {
  Page,
  onMount,
  FormGroup,
  DatePicker,
  SubmitButton,
} from "components/common";
import Select from "react-select";
import { withOrganisationContextConsumer } from "contexts/OrganisationContext";
import { formatDate } from "../../../services/util";
import moment from "moment";
import { ReportContainer } from "./components";
import { TrackingCategories } from "./tracking-categories/TrackingCategories";
import { withDefaultReportParams } from "./hooks/useDefaultReportParams";

export const BalanceSheet = ({
  data,
  item: itemProp,
  handleSubmit,
  setState,
  timeframes,
  periods,
  settings,
  t,
  organisation,
  onExport,
  dispatch,
}) => {
  const [item, setItem] = useState(itemProp);

  return (
    <Page printTitle={false}>
      <LocalForm
        className="d-print-none"
        getDispatch={(dispatch) => setState({ dispatch })}
        onSubmit={handleSubmit}
        onChange={setItem}
        initialState={item}
      >
        <div className="d-flex align-items-center">
          <FormGroup label="Date" className="mr-3">
            <DatePicker model=".date" className="form-control" />
          </FormGroup>
          <FormGroup label="Periods" className="mr-3" addControlClass={false}>
            <Control.select
              component={Select}
              simpleValue
              style={{ minWidth: "10rem",backgroundColor:'#F4F7FE'}}
              options={periods}
              searchable={false}
              model=".periods" 
              placeholder={t('Select...')}
            />
          </FormGroup>
          <FormGroup label="Timeframe" className="mr-3" addControlClass={false}>
            <Control.select
              component={Select}
              simpleValue
              style={{ minWidth: "10rem",backgroundColor:'#F4F7FE'}}
              options={timeframes}
              searchable={false}
              model=".timeframe" 
              placeholder={t('Select...')}
            />
          </FormGroup>
          <FormGroup label="&nbsp;" className="mr-3">
            <FormGroup label="Cash transactions only" check>
              <Control.checkbox model=".paymentsOnly" />
            </FormGroup>
          </FormGroup>
          <TrackingCategories/>
          <FormGroup label="&nbsp;">
            <SubmitButton size="sm" className="d-block">
              <Trans>Update</Trans>
            </SubmitButton>
          </FormGroup>
        </div>
      </LocalForm>
      <div className="d-none d-print-block">
        {settings.logo ? (
          <div className="mb-4 d-flex justify-content-end">
            <img style={{ maxHeight: 150 }} src={settings.logo} alt="logo" />
          </div>
        ) : null}
        <div className="d-flex justify-content-between mb-5">
          <div>
            <h1>
              {data.ReportTitles[0]}
            </h1>
          </div>
        </div>
      </div>
      <ReportContainer
        report={data}
      />
    </Page>
  );
};

const loadReport = (item, xero) =>
  xero.get("reports/BalanceSheet", {
    params: {
      extra_params: item,
    },
  }).get("data");

export const enhance = compose(
  withOrganisationContextConsumer,
  withDefaultReportParams(() => ({
    date: formatDate(moment().endOf("month")),
    periods: 1,
    timeframe: "YEAR",
  })),
  onMount(({ xero, fetchSettings, fetchOrganisation, item }) => () => {
    return Promise.props({
      data: loadReport(item, xero),
      settings: fetchSettings(),
      organisation: fetchOrganisation(),
      item,
    });
  }),
  withPropsOnChange(["t"], ({ t }) => ({
    periods: range(1, 11 + 1).map((i) => ({ label: i, value: i })),
    timeframes: [
      ["MONTH", t("Month")],
      ["QUARTER", t("Quarter")],
      ["YEAR", t("Year")],
    ].map(([value, label]) => ({ label, value })),
  })),
  withHandlers({
    handleSubmit:
      ({ setState, xero, dispatch, setReportParams }) =>
      (item) => {
        setReportParams(item);
        return loadReport(item, xero)
          .then((data) => setState({ data }))
          .finally(() => dispatch(actions.setSubmitted("local", true)));
      },
  })
);

export default enhance(BalanceSheet);
